/**
 * NotificationsShell — domain frame for the Wave-8 notifications spine.
 *
 * Houses the wiring that decides which template fires for which event,
 * who receives it, on which channels, and at what priority. Edits here
 * affect every cart, every customer notification, every SystemOps card —
 * make changes deliberately.
 *
 * Sub-tabs: Event Bindings, Opt-Outs, and Dispatch History (the last two
 * migrated from ROP-teams Admin 2026-06-16). NotificationTemplates + Task
 * Templates slot in as siblings as their editors land.
 */

import { useAuth } from '@/contexts/AuthContext';
import { DomainShell } from '@/components/DomainShell';

const REQ = ['SuperAdmin', 'Admin', 'SysOpsManager'] as const;

const SUBNAV = [
  { slug: 'event-bindings', label: 'Event Bindings', requiredRoles: REQ },
  { slug: 'templates', label: 'Notification Templates', requiredRoles: REQ },
  { slug: 'opt-outs', label: 'Opt-Outs', requiredRoles: REQ },
  { slug: 'dispatch-history', label: 'Dispatch History', requiredRoles: REQ },
];

export function NotificationsShell(): JSX.Element {
  const { user } = useAuth();
  return (
    <DomainShell
      title="Tasks & Templates"
      description="The Wave-8 notifications spine. Event Bindings map each platform event (cart-processed, signing-bounced, sla-breach, …) to a default template, the channels it fires on, the recipient resolver, and a priority. Notification templates, opt-outs, and task templates plug into the same shell as their editors land."
      basePath="/retail/notifications"
      items={SUBNAV.map((s) => ({
        slug: s.slug,
        label: s.label,
        requiredRoles: s.requiredRoles,
      }))}
      userRoles={user?.roles ?? []}
    />
  );
}
